export default "__VITE_ASSET__B1rEcHqj__"